export enum EAntIconUrl {
  AIM_OUTLINED = 'aim_outlined',

  APPSTORE_OUTLINED = 'appstore_outlined',

  ARROW_DOWN_OUTLINED = 'arrow_down_outlined',
  ARROW_RIGHT_OUTLINED = 'arrow_right_outlined',
  ARROW_LEFT_OUTLINED = 'arrow_left_outlined',
  ARROW_UP_OUTLINED = 'arrow_up_outlined',

  AUDIT_OUTLINED = 'audit_outlined',

  BANK_OUTLINED = 'bank_outlined',

  BARS_OUTLINED = 'bars_outlined',

  BELL_OUTLINED = 'bell_outlined',

  CLOSE_CIRCLE_OUTLINED = 'close_circle_outlined',
  CLOSE_OUTLINED = 'close_outlined',

  CODE_OUTLINED = 'code_outlined',

  COMPASS_OUTLINED = 'compass_outlined',

  COPY_OUTLINED = 'copy_outlined',

  PLUS_CIRCLE_OUTLINED = 'plus_circle_outlined',
  PLUS_OUTLINED = 'plus_outlined',

  EDIT_OUTLINED = 'edit_outlined',
  EDIT_FILLED = 'edit_filled',

  FILE_OUTLINED = 'file_outlined',
  FILE_PDF_OUTLINED = 'file_pdf_outlined',

  FILTER_OUTLINED = 'filter_outlined',

  FOLDER_OPEN_OUTLINED = 'folder_open_outlined',
  FOLDER_OUTLINED = 'folder_outlined',

  HOME_OUTLINED = 'home_outlined',

  GLOBAL_OUTLINED = 'global_outlined',

  HEAT_MAP_OUTLINED = 'HeatMapOutlined',

  INFO_OUTLINED = 'info_outlined',
  INFO_CIRCLE_OUTLINED = 'info_circle_outlined',

  LOADING_OUTLINED = 'loading_outlined',

  LOCK_OUTLINED = 'lock_outlined',

  LOGIN_OUTLINED = 'login_outlined',
  LOGOUT_OUTLINED = 'logout_outlined',

  MORE_OUTLINED = 'more_outlined',

  MINUS_OUTLINED = 'minus_outlined',

  MENU_OUTLINED = 'menu_outlined',

  DELETE_OUTLINED = 'delete_outlined',
  DOLLAR_OUTLINED = 'dollar_outlined',

  SHOP_OUTLINED = 'shop_outlined',
  SHOPPING_CART_OUTLINED = 'shopping_cart_outlined',
  SNIPPETS_OUTLINED = 'snippets_outlined',

  STAR_OUTLINED = 'star_outlined',
  SEARCH_OUTLINED = 'search_outlined',

  STOP_OUTLINED = 'stop_outlined',

  SYNC_OUTLINED = 'sync_outlined',

  UNDO_OUTLINED = 'undo_outlined',

  USER_OUTLINED = 'user_outlined',

  VIDEO_CAMERA_OUTLINED = 'video_camera_outlined',
  DESKTOP_OUTLINED = 'desktop_outlined',

  CAMERA_OUTLINED = 'camera_outlined',
}
